// extracted by mini-css-extract-plugin
export var container = "SidePromote-module--container--M3jGp";
export var imageContainer = "SidePromote-module--imageContainer--UB038";
export var testimonial = "SidePromote-module--testimonial--llRM9";
export var whySignup = "SidePromote-module--whySignup--tUhqo";